import React from 'react';
import { Lottie } from '@crello/react-lottie';

import { formatTimer, replace } from '../config/constants';

import { useStateValue } from '../state';

import Icon from './Icon';

export default ({ quantities, step, steps, onClick }) => {
  const interval = React.useRef(null);
  const [{
    defaultTime,
    time,
  }, setState] = React.useState({
    defaultTime: 0,
    time: 0,
  });
  const [{
    cup: {
      count,
    },
    timer: {
      action,
      play,
    },
  }, dispatch] = useStateValue();
  const newSteps = count === 2 ? steps : steps.filter(step => !step.condition);

  React.useEffect(() => {
    if (action === 'repeat') {
      setState((prevState) => ({
        ...prevState,
        time: defaultTime,
      }));
    }
  }, [action, defaultTime]);

  React.useEffect(() => {
    if (play && time > 0) {
      interval.current = setInterval(() => {
        setState((prevState) => ({
          ...prevState,
          time: time - 1,
        }));
      }, 1000);

      return () => {
        clearInterval(interval.current);

        interval.current = null;
      };
    }
  }, [dispatch, play, time]);

  React.useEffect(() => {
    if (steps[step].time) {
      setState((prevState) => ({
        ...prevState,
        defaultTime: steps[step].time,
        time: steps[step].time,
      }));
    }
  }, [step, steps]);

  return (
    <div className="direction">
      <div className="direction--animation">
        <Lottie config={{
          animationData: steps[step].animation,
          loop: true,
        }}/>
      </div>
      <div className="direction--detail">
        <div className="direction--detail--info">
          <span className="direction--detail--info-title">STEP {step + 1}</span>
          <span className="direction--detail--info-sub">{replace(newSteps[step].direction, quantities[count - 1])}</span>
          <div className="direction--detail--info-dot">
            {newSteps.map((_, index) => (
              React.createElement(Icon, {
                className: step === index ? 'icon--dot-active' : null,
                key: index,
                src: 'dot',
              })
            ))}
          </div>
        </div>
        {newSteps[step].time && (
          <div className="direction--detail--timer">
            <div className="direction--detail--timer-container">
              <div className="direction--detail--timer-container-text text-align--center">
                <span className={time !== 0 ? "direction--detail--timer-container-text-title" : "direction--detail--timer-container-text-title text--red"}>{formatTimer(time)}</span>
              </div>
              <div className="direction--detail--timer-container-action">
                {play ? (
                  <Icon
                    className={(play && time > 0) ? "icon--pause-active" : null}
                    src="pause"
                    onClick={() => onClick('pause')}
                  />
                ) : (
                  <Icon
                    className="icon--play-active"
                    src="play"
                    onClick={() => onClick('play')}
                  />
                )}
                <Icon
                  className={(play || action === 'pause') ? "icon--repeat-active" : null}
                  src="repeat"
                  onClick={() => onClick('repeat')}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className={step !== 0 ? 'page--footer' : 'page--footer justify-content-end'}>
        {step !== 0 && (
          <div className="page--footer-prev" onClick={() => {onClick('prev')}}>
            <span className="page--footer-prev-title">
              Prev
            </span>
          </div>
        )}
        {step !== (newSteps.length - 1) ? (
          <div className="page--footer-next" onClick={() => {onClick('next')}}>
            <span className="page--footer-button-title">
              Next
            </span>
          </div>
        ) : (
          <div className="page--footer-next" onClick={() => onClick('done')}>
            <span className="page--footer-button-title">
              Done
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
